import { useContext } from 'react';
import Context from './Context';

export default function useInterviewApi() {
  const { interview } = useContext(Context);
  return interview;
}
